const coreApi: string = process.env.REACT_APP_CORE_API + "api/users/v1/";
const authApi: string = process.env.REACT_APP_AUTH_API + "BptglobalUser/";

const apiUrl: { [key: string]: string } = {
    profileUrl: coreApi,
    sendMobileOtpUrl: authApi + 'send_otp',
    verifyMobileOtpUrl: authApi + 'verify_otp',
}

export default apiUrl;